import { Form, InputNumber } from 'antd';

import { TFieldProps } from 'types';

import { withToggleField } from '../../HOCs';

const { Item } = Form;

export const FormInputNumber = ({
  max,
  min = 0,
  name,
  label,
  rules,
  prefix,
  hidden,
  tooltip,
  isToggle,
  disabled,
  precision = 2,
  addonAfter,
  placeholder,
  inputStyles,
  itemClassName,
}: Omit<TFieldProps, 'type'>) => {
  const Input = isToggle ? withToggleField(InputNumber) : InputNumber;

  return (
    <Item
      name={name}
      rules={rules}
      label={label}
      hidden={hidden}
      tooltip={tooltip}
      labelAlign='left'
      className={itemClassName}
      normalize={(value) => (value || value === 0 ? Number(value) : null)}
    >
      <Input
        min={min}
        max={max}
        className='w-full'
        style={inputStyles}
        disabled={disabled}
        prefix={prefix}
        precision={precision}
        addonAfter={addonAfter}
        placeholder={placeholder}
        parser={(value) => value?.replace(/\$\s?|(,*)/g, '') || ''}
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      />
    </Item>
  );
};
